import {IconButton, useTranslationContext} from 'platform/components';
import {Heading, Text} from 'platform/foundation';

import {useEagGridStore} from '../../store/useEagGridStore';

export function MaximizedGridHeader(props: {title: string}) {
  const t = useTranslationContext();
  const store = useEagGridStore();

  return (
    <div className="flex shrink-0 items-center justify-between gap-4 border-b border-general-separator bg-white p-3">
      <Heading size={3}>{props.title}</Heading>
      <div className="flex items-center gap-3">
        <Text size="small" color="tertiary">
          {t('general.labels.pressEscToExit')}
        </Text>
        <IconButton
          aria-label={t('general.actions.exitFullScreen')}
          icon="navigation/fullscreen_exit"
          onClick={() => store.setIsMaximized(false)}
        />
      </div>
    </div>
  );
}
